/**
 * Generate a UUID v4
 * @returns {string} A UUID string in the format xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
export function generateUUID() {
    // 使用crypto API如果可用（更安全的随机数）
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        try {
            const buffer = new Uint8Array(16);
            crypto.getRandomValues(buffer);

            // 设置版本号 (4) 和变体位
            buffer[6] = (buffer[6] & 0x0f) | 0x40; // 版本 4
            buffer[8] = (buffer[8] & 0x3f) | 0x80; // 变体 10

            // 将字节数组转换为十六进制字符串的安全方式
            let hex = '';
            for (let i = 0; i < buffer.length; i++) {
                const byte = buffer[i];
                const hexByte = (byte & 0xff).toString(16).padStart(2, '0');
                hex += hexByte;
            }

            return [
                hex.slice(0, 8),
                hex.slice(8, 12),
                hex.slice(12, 16),
                hex.slice(16, 20),
                hex.slice(20, 32)
            ].join('-');
        } catch (error) {
            // 如果crypto API出现问题，使用降级方案
            console.warn('Crypto API failed:', error);
        }
    }

    // 降级方案：使用Math.random()
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
